export const VALIDA_SENHA_REGEX =
  /^(?=.*[@!#$%^=&*()/\\])[@!#$%^=&*()/\\a-zA-Z0-9]{8,20}$/;
